var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_510_144533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_510_144533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59805 8L5.99805 6.95L7.37305 8L6.84805 6.3L8.24805 5.2H6.54805L5.99805 3.5L5.44805 5.2H3.74805L5.12305 6.3L4.59805 8ZM1.99805 10C1.72305 10 1.48763 9.90208 1.2918 9.70625C1.09596 9.51042 0.998047 9.275 0.998047 9V7.3125C0.998047 7.22083 1.02721 7.14167 1.08555 7.075C1.14388 7.00833 1.21888 6.96667 1.31055 6.95C1.51055 6.88333 1.67513 6.7625 1.8043 6.5875C1.93346 6.4125 1.99805 6.21667 1.99805 6C1.99805 5.78333 1.93346 5.5875 1.8043 5.4125C1.67513 5.2375 1.51055 5.11667 1.31055 5.05C1.21888 5.03333 1.14388 4.99167 1.08555 4.925C1.02721 4.85833 0.998047 4.77917 0.998047 4.6875V3C0.998047 2.725 1.09596 2.48958 1.2918 2.29375C1.48763 2.09792 1.72305 2 1.99805 2H9.99805C10.273 2 10.5085 2.09792 10.7043 2.29375C10.9001 2.48958 10.998 2.725 10.998 3V4.6875C10.998 4.77917 10.9689 4.85833 10.9105 4.925C10.8522 4.99167 10.7772 5.03333 10.6855 5.05C10.4855 5.11667 10.321 5.2375 10.1918 5.4125C10.0626 5.5875 9.99805 5.78333 9.99805 6C9.99805 6.21667 10.0626 6.4125 10.1918 6.5875C10.321 6.7625 10.4855 6.88333 10.6855 6.95C10.7772 6.96667 10.8522 7.00833 10.9105 7.075C10.9689 7.14167 10.998 7.22083 10.998 7.3125V9C10.998 9.275 10.9001 9.51042 10.7043 9.70625C10.5085 9.90208 10.273 10 9.99805 10H1.99805ZM1.99805 9H9.99805V7.725C9.68971 7.54167 9.44596 7.29792 9.2668 6.99375C9.08763 6.68958 8.99805 6.35833 8.99805 6C8.99805 5.64167 9.08763 5.31042 9.2668 5.00625C9.44596 4.70208 9.68971 4.45833 9.99805 4.275V3H1.99805V4.275C2.30638 4.45833 2.55013 4.70208 2.7293 5.00625C2.90846 5.31042 2.99805 5.64167 2.99805 6C2.99805 6.35833 2.90846 6.68958 2.7293 6.99375C2.55013 7.29792 2.30638 7.54167 1.99805 7.725V9Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalActivity);
export default __webpack_public_path__ + "static/media/local_activity.a741d57562ab0a46c0bf3264088349e1.svg";
export { ForwardRef as ReactComponent };